// import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
// import SummaryApi from "../common/SummaryApi";
// import axios from "axios";
// import { getLocalCart } from "../helpers/cartHelper";

// const CartContext = createContext();

// export const CartProvider = ({ children }) => {
//   const [cartCount, setCartCount] = useState(0);
//   const [token, setToken] = useState(localStorage.getItem("token"));

//   // 🔹 listen for login / logout
//   useEffect(() => {
//     const syncAuth = () => {
//       setToken(localStorage.getItem("token"));
//     };

//     window.addEventListener("storage", syncAuth);
//     window.addEventListener("auth-change", syncAuth);

//     return () => {
//       window.removeEventListener("storage", syncAuth);
//       window.removeEventListener("auth-change", syncAuth);
//     };
//   }, []);

//   const loadCartCount = useCallback(async () => {
//     try {
//       if (token) {
//         // LOGGED IN
//         const res = await axios({
//           url: SummaryApi.getCartItems.url,
//           method: SummaryApi.getCartItems.method,
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         setCartCount(res.data.items?.length || 0);
//       } else {
//         // GUEST
//         const guestCart = getLocalCart();
//         setCartCount(guestCart.length);
//       }
//     } catch (err) {
//       console.error("Cart count load failed", err);
//     }
//   }, [token]);

//   useEffect(() => {
//     loadCartCount();
//   }, [loadCartCount]);

//   return (
//     <CartContext.Provider
//       value={{
//         cartCount,
//         refreshCart: loadCartCount,
//       }}
//     >
//       {children}
//     </CartContext.Provider>
//   );
// };

// export const useCart = () => useContext(CartContext);

import React, { createContext, useContext, useEffect, useState } from "react";
import SummaryApi from "../common/SummaryApi";
import axios from "axios";
import { getLocalCart } from "../helpers/cartHelper";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const refreshCart = async () => {
    try {
      const token = localStorage.getItem("token");

      if (token) {
        // LOGGED IN
        const res = await axios({
          url: SummaryApi.getCartItems.url,
          method: SummaryApi.getCartItems.method,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // const totalQty = res.data.items?.reduce(
        //   (sum, item) => sum + (item.quantity || 1),
        //   0
        // ) || 0;

        // setCartCount(totalQty);
        setCartCount(res.data.items.length);

      } else {
        // GUEST
        // const guestCart = getLocalCart();
        // const totalQty = guestCart.reduce(
        //   (sum, item) => sum + (item.quantity || 1),
        //   0
        // );
        // setCartCount(totalQty);
        const guestCart = getLocalCart();
        setCartCount(guestCart.length);
      }
    } catch (err) {
      console.error("Cart count load failed", err);
      setCartCount(0);
    }
  };

  // 🔥 load cart count on app start
  useEffect(() => {
    refreshCart();
  }, []);

  // 🔥 sync across tabs (login/logout)
  useEffect(() => {
    const syncCart = () => refreshCart();
    window.addEventListener("storage", syncCart);
    return () => window.removeEventListener("storage", syncCart);
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, refreshCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
